import { call, takeLatest, put } from 'redux-saga/effects';

import getAPI from 'core/api/iv-back';
import { YieldOf } from 'types/utils';
import { sagaWithCallback } from 'core/store/utils';

import { logout } from '../api-auth/actions';
import { fetchedTranslationLanguages, fetchTranslationLanguages } from './actions';

export function* fetchTranslationLanguagesSaga() {
  const { getEnabledTranslationLanguages } = getAPI();
  const response: YieldOf<typeof getEnabledTranslationLanguages> = yield call(getEnabledTranslationLanguages);
  const { data = [], ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(fetchedTranslationLanguages(data));
    return data;
  } else {
    const error = problem || 'unknown';
    yield put(fetchedTranslationLanguages(undefined, error));
    throw new Error('fetch sendStatus failed: ' + problem);
  }
}

export default function* saga() {
  yield takeLatest(fetchTranslationLanguages.type, sagaWithCallback(fetchTranslationLanguagesSaga));
}
